import { useContext } from "react";
import { ContentTypeView } from "nystem-components";
import { CastContext } from "../../client/castContext.js";
import CastLocation from "./location.js";

const CastPlayer = () => {
  const { state } = useContext(CastContext);
  return state.connected ? (
    <p role="status" className="p-8 text-center text-lg">
      {state.nativePlayback ? "Playing in the AirPlay player. Use the controls below."
        : state.browserPlayback ? "AirPlay playback controls are below."
          : "Playing on your TV. Use the controls below."}
    </p>
  ) : (
    <CastLocation>
      <ContentTypeView contentType="video" format="player" />
    </CastLocation>
  );
};

export default CastPlayer;
